<template>
  <div class="page-landing page-default">
    <header class="header">
      <div class="row align-middle align-center">
        <figure>
          <nuxt-img
            src="/images/webinars/banner-webinars.png"
            alt=""
            title="Webinars"
            width="536"
            height="382"
            format="webp"
            preload
          />
        </figure>
        <h1>
          <span class="heading-xl">Webinars</span>
        </h1>
      </div>
    </header>
    <section class="section bg-highlighter-500 text-center">
      <div class="row align-center align-middle">
        <div class="columns small-8">
          <h2 class="heading-2">
            Join educators and other experts to help you make more moments that matter in the
            classroom.
          </h2>
        </div>
      </div>
    </section>
    <section class="section section-list">
      <ul class="webinars-list no-list">
        <li v-for="webinar in webinars" :key="webinar.link" class="row align-middle">
          <div class="columns small-12 large-6">
            <div v-if="webinar.youtube_id" class="flex-video">
              <iframe
                width="560"
                height="315"
                :src="'https://www.youtube.com/embed/' + webinar.youtube_id"
                title="View this webinar on YouTube"
                allow="autoplay; encrypted-media"
                allowfullscreen
                webkitallowfullscreen
                msallowfullscreen
              ></iframe>
            </div>

            <figure v-else-if="webinar.image">
              <img
                :src="webinar.image"
                :alt="webinar.title"
                height="420"
                width="1200"
                loading="lazy"
              />
            </figure>
          </div>

          <div class="columns small-12 large-6">
            <h3>{{ webinar.title }}</h3>
            <p>{{ webinar.description }}</p>

            <p>
              <a
                v-if="webinar.youtube_id"
                :href="'https://www.youtube.com/watch?v=' + webinar.youtube_id"
                title="View this webinar on YouTube"
                @click="trackWebinarClick(webinar.title)"
                class="button button-primary"
              >
                Watch now
              </a>
            </p>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'WebinarsIndex',
  data() {
    return {
      title: 'Webinars',
      description:
        'Join Teach Starter experts for industry insights, teacher stories and classroom advice. Live and on-demand.',
      webinars: [
        {
          title: 'Let’s Explore Teach Starter',
          description:
            'Join us as resources manager Paul takes you through the Teach Starter platform, jam-packed with teacher-designed resources and activities that will capture your students’ minds. ',
          image: '/images/webinars/website-walkthrough/website-walkthrough-banner-02.jpg',
          youtube_id: 'F_dUV49zWOY',
        },
        {
          title: 'Set Your Classroom Up for Success',
          description:
            'Teach Starter team member and early years teacher, Holly will guide you through the building blocks for creating an organised and effective classroom setup.',
          image: '/images/webinars/classroom-success/set-up-classroom-success-banner.jpg',
          youtube_id: 'OUoXt92p_7Y',
        },
        {
          title: 'Beginning Your Teaching Journey',
          description:
            'Join us as we hear inspiring advice from Teach Starter staff, experienced teachers and fellow beginning teachers.',
          youtube_id: 'moY3eNxIDAk',
        },
        {
          title: 'A Conversation With Know Your Country',
          description:
            'Join Bron, Dr Scott Winch and Aunty Phyllis Marsh as they discuss how you can create student connections to people, culture and country in your classroom.',
          youtube_id: 'a-OiFV8-NNM',
        },
        {
          title: 'Teaching Handwriting: Hints, Tips & Strategies',
          description:
            'Holly will guide you through the foundation of pre-writing, fine motor development, letter formation and provide hints, tips and strategies for teaching handwriting.',
          youtube_id: '3ubG-L8z4PE',
        },
        {
          title:
            'Fostering an Inclusive Classroom Using the Universal Design for Learning Framework',
          description:
            'In this webinar, our expert guest, Amanda from Illume learning will guide you through the basics of the Universal Design for Learning framework and explain the importance of fostering inclusion within our diverse classrooms.',
          youtube_id: 'JOYYC0lXRYI',
          image: '/images/webinars/banner-inclusive-classroom.png',
        },
        {
          title: 'Surviving to Thriving: Practical Strategies for Teacher Wellbeing',
          description:
            'In this webinar, our special guest Jessica Mason will provide practical strategies and advice to support your emotional health and wellbeing as teachers.',
          youtube_id: '8IQx947M-9s',
        },
        {
          title: 'NAIDOC Week & Beyond: Embedding First Nations Perspectives in the Classroom',
          description:
            'This webinar will discuss expanding the breadth of students’ learning to focus on the histories and perspectives of First Nations Australians and how to use these learnings as foundations for helping to move towards reconciliation.',
          youtube_id: 'WnEvVaYizHY',
        },
        {
          title: 'Gamified Learning Using Interactive PowerPoints',
          description:
            'Join Tom, an experienced teacher and resource producer as he guides you through our range of Interactive PowerPoints, the perfect tool for gamifying the classroom. We outline how to maximise PowerPoint to increase classroom engagement.',
          youtube_id: 'zAwjTsMiOqQ',
        },
        {
          title: 'Why Classroom Brain Breaks are a No-Brainer',
          description:
            'Teach Starter team member and experienced teacher, Holly guides you through how quick brain breaks can be a teacher’s best friend for behaviour strategy! We outline easy and fun ways to get your students to take a brain break, even for just a few minutes.',
          youtube_id: 'wRE2EOfrxr0',
        },
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
  methods: {
    trackWebinarClick: function (title) {
      let analyticsName = 'webinars.';
      if (title.includes('|')) {
        analyticsName = analyticsName
          .concat(title.split('|')[0].trim().replace(/\s+/g, '_'))
          .concat('.')
          .concat(title.split('|')[1].trim().replace(/\s+/g, '_'));
      } else {
        analyticsName = analyticsName.concat(title.trim().replace(/\s+/g, '_'));
      }
      this.$mzAnalyticsApi({
        event: 'click',
        name: analyticsName,
        productArea: 'content',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.heading-xl {
  margin-left: 1.5rem;
}
.bg-highlighter-500 {
  h2 {
    margin: 0;
  }
}

.webinars-list {
  li {
    padding: $base-padding * 2 0;
  }
}

h1 {
  margin: 0;
}

h3 {
  margin-top: $base-padding;
}

.header {
  margin: 0 $base-padding * 2 $base-padding-two-thirds * 5 $base-padding * 2;
  padding: $base-padding-two-thirds * 5 $base-padding * 2;
}

@media #{$medium-up} {
  .header {
    padding: 5rem;
    margin-left: 5rem;
    margin-right: 5rem;
  }
  .margin-bottom {
    margin-bottom: 2rem;
  }
}
</style>
